import React from 'react';
import { Navigate } from 'react-router-dom';
import __ from 'lodash';
import { TTP_HOME_URL } from 'Config';

const PrivateRoute = ({
  auth,
  roles,
  privilege,
  component: ComponentToRender,
  renderPropsToComponent,
  ...props
}) => {
  const renderComponent = () => {
    const componentProps =
      renderPropsToComponent && typeof renderPropsToComponent === 'function'
        ? renderPropsToComponent(props)
        : props;

    // Check if the user is authenticated
    if (!auth || !auth.fetched || !auth.user) {
      location.href = `${TTP_HOME_URL.replace(/\/+$/, '')}?goto=${location.href}`;
      return null;
    }

    const loggedAs = auth.loggedAs;

    // Check user roles
    if (!roles || __.isEmpty(roles)) {
      return <ComponentToRender {...componentProps} />;
    }

    const ttpRole = `TTP_${auth.user.type || ''}`.toUpperCase();

    // Validate user role or privilege
    if (
      (Array.isArray(roles) && roles.some((role) => role === loggedAs || role === ttpRole)) ||
      roles === loggedAs ||
      roles === ttpRole ||
      (privilege && auth.preference && auth.preference[privilege] === 1)
    ) {
      return <ComponentToRender {...componentProps} />;
    }

    return <Navigate to="/unauthorized" state={{ from: props.location }} />;
  };

  // Call renderComponent directly to return JSX
  return renderComponent();
};

export default PrivateRoute;
